import { render, staticRenderFns } from "./karuniarohani_detail.vue?vue&type=template&id=9b9357a8&"
import script from "./karuniarohani_detail.vue?vue&type=script&lang=js&"
export * from "./karuniarohani_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports